import getPatientAnalytics from "@custom/rtk-apis/analytics/getPatientAnalytics";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getPatientAnalyticsSlice = createSlice({
  name: "getPatientAnalyticsSlice",
  initialState,
  reducers: {
    clearPatientAnalytics: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPatientAnalytics.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getPatientAnalytics.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(getPatientAnalytics.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getPatientAnalyticsSlice.reducer;
export const { clearPatientAnalytics } = getPatientAnalyticsSlice.actions;
